import { render, staticRenderFns } from "./sandbox-promotions-history.vue?vue&type=template&id=4c2017ca&scoped=true&"
import script from "./sandbox-promotions-history.vue?vue&type=script&lang=tsx&"
export * from "./sandbox-promotions-history.vue?vue&type=script&lang=tsx&"
import style0 from "./sandbox-promotions-history.vue?vue&type=style&index=0&id=4c2017ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2017ca",
  null
  
)

export default component.exports